

/// <reference path="DBDocumentLine.ts" />

// Generated class DBDocumentTitleLine_ManagedObject

class DBDocumentTitleLine_ManagedObject extends DBDocumentLine
{
}
